<template>
<div class="vld-parent" style="width: 100%;height: 100%;">
  <loading :active.sync="isLoading" :is-full-page="true"></loading>
<ag-grid-vue style="width: 100%;height: 100%;"
                 class="ag-theme-balham"                 
                 :columnDefs="columnDefs" 
                 :gridOptions="gridOptions"
                 :rowMultiSelectWithClick="true"
                  :defaultColDef="defaultColDef"
                 :rowSelection="rowSelection"
                 :rowHeight=50
                 :rowData="unpostedInvoices">
                </ag-grid-vue>
</div>
</template>

<script>    
window.isFirstColumn = function isFirstColumn(params) {
  var displayedColumns = params.columnApi.getAllDisplayedColumns();
  var thisIsFirstColumn = displayedColumns[0] === params.column;
  return thisIsFirstColumn;
};
    import {AgGridVue} from "ag-grid-vue";
    import { invoiceService } from './../../services/'    
    import { EventBus } from './../../eventbus/event-bus.js';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import moment from 'moment';
  export default {
    name: 'PostLedgePage',
    data: () => ({      
       isLoading: true,
        fullPage: true,
        gridOptions: null,
        gridApi: null,  
        snackbar: false,
        rowSelection: null,
        unpostedInvoices:[],
        response:null,
         columnDefs:[          
          { headerName: 'Customer No', field:'customerId', headerCheckboxSelectionFilteredOnly: true,  checkboxSelection: true},         
          { headerName: 'Customer Name', field:'customer.name'},
          { headerName: 'Customer Balance',valueFormatter: params => parseFloat((params.data.customer.balance)+parseFloat(params.data.total)).toFixed(2)},
          { headerName: 'Invoice No', field:'id'},
          { headerName: 'Inv Date', field:'createdAt',width:100, valueFormatter: params => moment(params.data.createdAt).format('DD-MM-YYYY')},  
          { headerName: 'Locator', field:'locator',width:100},
          { headerName: 'Description', field:'description'},
          { headerName: 'Inv Total', field:'total',width:100},
          { headerName: 'Supplier Name', field:'supplier.name'},
          { headerName: 'Cost', field:'cost',valueFormatter: params => parseFloat(params.data.cost).toFixed(2)},
          { headerName: 'Server By', field:'User.name'}
        ], 
    }),
    components: {
            AgGridVue,            
            Loading
    },    
    methods: { 
      loadUnpostedInvoices() {
        let self=this        
        self.isLoading=true
        invoiceService.getUnpostedInvoices().then(unpostedInvoices=> {
          self.unpostedInvoices=unpostedInvoices
          self.isLoading=false
        })
    },           
    },
    beforeMount() {
      this.gridOptions = {};
      this.rowSelection = 'multiple';
      this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,      
      headerCheckboxSelection: window.isFirstColumn,
      checkboxSelection: window.isFirstColumn,
    };
    },
    
    
    mounted () {     
        this.gridApi = this.gridOptions.api;   
        this.loadUnpostedInvoices()
        let self=this         
        EventBus.$on('postInvoiceAction', function () {
          self.isLoading=true
          let selectedNodes = self.gridApi.getSelectedNodes();
          let selectedData = selectedNodes.map(node => node.data.id);          
          invoiceService.postInvoices(selectedData).then(unpostedInvoices=> {
              console.log(unpostedInvoices)
              self.loadUnpostedInvoices()
          })
        });
    }
  }
 
  
</script>
<style >
.ag-theme-balham .ag-cell .ag-icon {
  display: flex;
  vertical-align:auto  
}

</style>
